module.exports = __webpack_public_path__ + "static/img/dusty.3525348f.png";